








































































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import {
  OpenRepairOrderViewModel,
  RoEmailViewModel,
  GetEmailDetailModel,
  RepairOrderResponseViewModel,
} from '@/models/fixedops/repairorder';
import { Base } from '../common/base';
import { repairOrderService } from '@/shared';

@Component({
  watch: {
    customerInformation(newVal, oldVal) {
      this.getEmailDetails(newVal);
    },
  },
  computed: {
    buttonType: {
      get() {
        if (this.email.customer && this.email.self) {
          return 'both';
        } else {
          if (this.email.customer) {
            return 'customer';
          } else {
            return 'self';
          }
        }
      },
    },
  },
  props: ['customerInformation', 'repairOrder'],
})
export default class EmailSendComponent extends Base {
  public emailModel: RoEmailViewModel = { storeId: 0, storeName: '' };
  public repairOrder: RepairOrderResponseViewModel;
  public email: any = {
    self: false,
    customer: false,
    from: '',
    froms: [],
  };
  public buttonType;
  public isLoaded: boolean = false;
  public disableSendEmail: boolean = false;
  public isEmailLoading: boolean = false;

  public mounted(): void {
    // mounted
  }

  public async getEmailDetails(model: OpenRepairOrderViewModel): Promise<void> {
    try {
      this.isLoaded = false;
      this.isEmailLoading = true;
      this.disableSendEmail = true;
      const searchModel: GetEmailDetailModel = {
        advisorEmail: '',
        customerEmail: model.customerEmail || '',
        attachmentId: '',
        customerKey: model.customerKey,
        customerName: model.customerName,
        roNumber: model.repairOrderNumber,
        serviceWriterId: model.serviceWriterId || model.serviceWriterID,
        storeName: this.repairOrder.storeName,
      };
      this.emailModel.view = 'list';
      this.emailModel.roNumber = model.repairOrderNumber;
      this.emailModel.storeId = this.repairOrder.storeId;
      this.emailModel.customerName = encodeURIComponent(
        JSON.stringify(model.customerName)
      );
      this.emailModel.customerEmail1 = model.customerEmail;

      this.emailModel.vinNumber = model.vin;
      this.emailModel.subject =
        this.repairOrder.storeName +
        this.$t('sendEmail.order') +
        model.repairOrderNumber;

      const response = await repairOrderService.getEmailDetails(searchModel);
      this.email.customer = false;
      this.email.self = false;
      this.email.froms = [];
      if (response.serviceAdvisorEmail) {
        this.email.froms.push(response.serviceAdvisorEmail);
      }
      if (response.loggedInUserEmail) {
        this.email.froms.push(response.loggedInUserEmail);
      }
      this.email.from =
        response.serviceAdvisorEmail || response.loggedInUserEmail;
      this.isLoaded = true;
    } catch (e) {
      this.close();
    } finally {
      this.isEmailLoading = false;
      this.disableSendEmail = false;
    }
  }

  public async sendEmail(): Promise<void> {
    try {
      this.disableSendEmail = true;
      if (!this.email.customer && !this.email.self) {
        this.showAlert(false, this.$t('sendEmail.selectCustomerOrSelf'));
        return;
      }

      const response = await repairOrderService.getRepairOrderDetails(
        this.emailModel.roNumber
      );
      const repairOrder = response;
      this.emailModel.status = repairOrder.status;
      this.emailModel.serviceAdvisor = repairOrder.serviceAdvisor;
      this.emailModel.serviceAdvisorEmail = repairOrder.advisorEmail;
      this.emailModel.fromEmailUserEmail = this.email.from;
      this.emailModel.buttonType = this.buttonType;
      await repairOrderService.sendROEmail(this.emailModel);
      this.showAlert(true, this.$t('sendEmail.roEmailSent'));
      this.close();
    } finally {
      this.disableSendEmail = false;
    }
  }

  public close(): void {
    this.$emit('onClose');
  }
}
